import _ from 'underscore';
import { mapState } from 'vuex';

import user from './preview/index.vue'

export default {
	name: 'users_list',
	props: {
		scroll : Number
	},

	components : {
		user
	},

	data : function(){

		return {
			loading : false,
			searchvalue : '',
			count : 0,
			sort : 'date_desc',
			payloadsSample : 'all',
			sorting : {

				date_asc : {
					text : 'date_asc',
					field : 'date',
					sort : 'asc'
				},
				date_desc : {
					text : 'date_desc',
					field : 'date',
					sort : 'desc'
				}
			},

		}

	},

	created() {
		

	},

	destroyed() {
	},

	watch: {
		tscrolly : function(){

			if (this.$refs['list']){

				if (this.$refs['list'].height() - 1000 < this.tscrolly + this.dheight){
					this.$refs['list'].next()
				}
				
			}
			
		}
	},
	computed: mapState({
		dheight: state => state.dheight,
		tscrolly : function(state){
			return this.scroll || state.tscrolly
		},
		auth : state => state.auth,

		payload : function(){

			var pl = {
				sortFields : [{
					field : this.sorting[this.sort].field,
					order : this.sorting[this.sort].sort
				}],
				fieldsFilter : {}
			}

			if(this.searchvalue){
				pl.fieldsFilter.email = {
					value : this.searchvalue,
					like : true
				}
			}

			pl.fieldsFilter = {
				...pl.fieldsFilter,
				...this.payloadsSamples[this.payloadsSample].payload
			}
			

			return pl
		
		},

		payloadsSamples : function(){
			return {
				partners : {
					text : 'partner.partners',
					payload : {
						type : 4
					}
				},

				users : {
					text : 'labels.users',
					payload : {
						type : 0
					}
				},

				all : {
					text : 'labels.all',
					payload : {
					}
				}
			}
		},

		menu : function(){

			return []

		},

		api : function(){
			
			return 'team.users.list'
			
		}
	}),

	methods : {

		payloadsSampleChanged : function(v){
			this.payloadsSample = v
		},

		reload : function(){
			if(this.$refs['list']) this.$refs['list'].reload()
		},

		search : function(v){
			this.searchvalue = v
		},

		setcount : function(v){
			this.count = v
		},

		sortchange : function(v){
			this.sort = v
		}
	},
}